import { render, staticRenderFns } from "./blankAfterDetail.vue?vue&type=template&id=712178a8&scoped=true"
import script from "./blankAfterDetail.vue?vue&type=script&lang=js"
export * from "./blankAfterDetail.vue?vue&type=script&lang=js"
import style0 from "./blankAfterDetail.vue?vue&type=style&index=0&id=712178a8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712178a8",
  null
  
)

export default component.exports